// extracted by mini-css-extract-plugin
export default {"form":"styles_form__z-WZH"};